var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReadyPage)?_c('div',{attrs:{"id":"app"}},[_c('AppLayout',[_c('router-view')],1),_c('Notification')],1):_c('Loader')}
var staticRenderFns = []

export { render, staticRenderFns }